import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, catchError, map, of } from 'rxjs';
import { environment } from '@env/environment';

@Injectable({
    providedIn: 'root',
})
export class HealthCheckService {
    private http = inject(HttpClient);

    private _isServerRunning = new BehaviorSubject<boolean>(true);
    isServerRunning$ = this._isServerRunning.asObservable();

    checkHealth() {
        // Attempt to hit the API base URL to check if server is reachable
        this.http.get(`${environment.apiBaseUrl}health`, { responseType: 'text' }).pipe(
            map(() => true),
            catchError(() => of(false))
        ).subscribe(isRunning => {
            this._isServerRunning.next(isRunning);
        });
    }
}
